import React, { useState } from "react";
import '../styles/ScreenConfirmation.css'
import { languageMessages } from "traductor/PaymentConfirmation";
import HTMLRenderer from "components/GlobalHTMLParser";
import Dialog from "components/OleDialog";
import BannerFamily from "components/BannerFamily";
import Stepper from "components/Stepper";
import { REACT_APP_COUNTRY_DEPLOY } from "config";

const IMG_TYPE_STEP_DEFAULT = 'auto';

const PaymentConfirmation = ({language, tipo, field1, isCardRegistration = false}: {language:string, tipo: string, field1: string, isCardRegistration?: boolean}) => {
    //const [open, setOpen] = useState(tipo === IMG_TYPE_STEP_DEFAULT);
    const [open, setOpen] = useState(true);

    /*useEffect(() => {
        setOpen(tipo === IMG_TYPE_STEP_DEFAULT);
        // eslint-disable-next-line
    }, [tipo]);*/
    const handleClose = () => {
        setOpen(false);
    }

    const isBRCardRegistration = REACT_APP_COUNTRY_DEPLOY === 'BR' && isCardRegistration;
    const titleKey = isBRCardRegistration ? 'cardRegistration' : tipo;
    const subtitleKey = isBRCardRegistration ? 'cardRegistration' : tipo;
    const interviewCopyKey = REACT_APP_COUNTRY_DEPLOY === 'INT' && tipo === 'pending' ? 'omitted' : tipo;

    return (
        <>
            {
                REACT_APP_COUNTRY_DEPLOY === 'BR' && <div className={`app-screen-confirmation${isBRCardRegistration ? ' app-screen-confirmation--card-registration' : ''}`}>
                    {!isBRCardRegistration && open && (
                        <Dialog
                            title={languageMessages[language].flywire.title}
                            img="../icon_information.svg"
                            subtitle={languageMessages[language].flywire.subtitle}
                            buttonText=""
                            classname="dialog__succes_flywire"
                            showClose={true}
                            onClose={handleClose}
                        />
                    )}
                    <div className='logo'>
                        <img src="../logo_official.png" alt="logo"/>
                    </div>
                    <div className="img-tablet">
                        <img src="../people-tablet.png" alt="img-mobile"/>
                    </div>
                    <div className="img-mobile">
                        <img src="../people-mobile.png" alt="img-mobile"/>
                    </div>
                    <div className="title"><HTMLRenderer html={languageMessages[language].title[titleKey]}/></div>
                    <div className="subtitle"><HTMLRenderer html={languageMessages[language].subtitle[subtitleKey].replace('{param1}', field1)}/></div>
                    {!isBRCardRegistration && (
                        <div className="steps">
                            {/*<img src={languageMessages[language].step[tipo]} alt="steps"/>*/}
                            <img src={languageMessages[language].step[IMG_TYPE_STEP_DEFAULT]} alt="steps"/>
                        </div>
                    )}
                    <div className="people">
                        <img src="../ASA-people.png" alt="people"/>
                    </div>
                    {!isBRCardRegistration && (
                        <div className="flywire">
                            {/*tipo === 'auto' && <HTMLRenderer html={languageMessages[language].flywire.disclaimer}/>*/}
                            <HTMLRenderer html={languageMessages[language].flywire.disclaimer}/>
                        </div>
                    )}
                </div>
            }
            {
                REACT_APP_COUNTRY_DEPLOY !== 'BR' && <div className='page__interview'>
                    <div className='header'>
                        <img src='./../logo_ole_transparent.svg' alt='Logo' className='logo' />
                    </div>
                    <div className='body'>
                        <div className='content'>
                            <div className='title'><HTMLRenderer html={languageMessages[language].title[interviewCopyKey]}/></div>
                            <div className='subtitle'><HTMLRenderer html={languageMessages[language].subtitle[interviewCopyKey].replace('{param1}', field1)}/></div>
                            {REACT_APP_COUNTRY_DEPLOY === 'INT' && <Stepper language={language} tipo={tipo} />}
                        </div>
                        <div className='banner'>
                            <BannerFamily />
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default PaymentConfirmation;